import {createTheme, MuiThemeProvider} from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import React, {Component} from 'react';
import {IntercomAPI} from 'react-intercom';
import toastr from "toastr";
import {Link} from 'react-router-dom';
import Theme from '../common/MuiTheme';

// import ReactGA from "react-ga";
import {Tag} from '@blueprintjs/core';

import * as authService from "../../services/authService";
import CreateTagModal from '../modals/CreateTagModal';
import DeleteTagModal from '../modals/DeleteTagModal';
import EditTagModal from '../modals/EditTagModal';
import ChartLoader from '../utils/chart-loader';
import Loader from "../utils/loader";

class Tags extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filtered: this.props.filteredTags,
            tags: this.props.tags,
            tableWidth: '',
            tagsPageSize: this.props.tagsPageSize,
            tagsLoading: this.props.tagsLoading,
            showCreateTagModal: false,
            showDeleteTagModal: false,
            showTagModal: false,
            selectedItem: ''
        };
        toastr.options = {};
    }


    async componentDidMount() {
        //  ReactGA.pageview(window.location.pathname + window.location.search);

        // let style = window.getComputedStyle(document.querySelector('main'), null);
        //
        const tableWidth = document.querySelector('main').offsetWidth - 120;
        // ;
        await this.setState({
            tableWidth
        })
    }

    componentDidUpdate = async () => {
        //console.log('next props tags:', this.props.tags);
        if (this.state.tags !== this.props.tags || this.state.filtered !== this.props.filteredTags) {

            let tags = await this.props.tags;
            let filteredTags = await this.props.filteredTags;
            const tableWidth = document.getElementById('tags-heading').offsetWidth;

            // console.log('cwrp tags:', tags);
            // console.log('cwrp page size:', this.props.tagsPageSize);
            await this.setState({
                tags: tags, filtered: filteredTags, tagsPageSize: this.props.tagsPageSize, tableWidth
            });
            // console.log('new tags :', this.state.tags)
        }
        if (this.state.tagsLoading !== this.props.tagsLoading) {
            await this.setState({tagsLoading: this.props.tagsLoading})
        }
    }

    noTagsRenderer = () => {
        return <div className='no-contacts-container panel-container margin-top-20'>
            <img alt='No tags' src="/img/emptyStates/tags_content_automation.gif"/>
            <h3>There are no tags yet.</h3>
            <div className='flex-direction-row justify-content-center'>
                <button id='tags_btn' data-target="#tagModal" onClick={() => this.setState({showCreateTagModal: true})}
                        className='btn-action margin-bottom-10'>
                    Create New Tag
                </button>
            </div>
        </div>
    };

    tableLoaderRenderer = () => {
        return <div className='table-loader-container'>
            <ChartLoader/>
        </div>
    }

    getMuiTheme = () => createTheme(Theme)

    render() {
        if (!this.props.selectedSource
            //    && !this.props.feeds_shared
        ) {
            return (

                <React.Fragment>
                    <h1 className='main-title'>Tags</h1>
                    <div className="row">
                        <div className="col-xs-12 text-center no-feeds-containers">
                            <div className="feed-msg">
                                <img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                                <p className="text-center ">{authService.getCurrentUserName()}</p>
                                <p>It looks like you haven't set up any workspaces yet. Add your first workspace, and
                                    start
                                    growing your audience.</p>
                                <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/>
                            </div>
                            <Link to='/workspace-name'>
                                <button className='btn-m btn-action' type="button">
                                    Create your first workspace
                                </button>
                            </Link>
                        </div>

                    </div>
                </React.Fragment>);
        }

        const columns = [{
            name: "tag", label: "Tags", options: {
                filter: false, sort: false, customBodyRender: (value, tableMeta, updateValue) => {
                    const item = this.state.tags[tableMeta.rowIndex];
                    return <Tag>
                        {item.tag}
                    </Tag>
                }
            }

        }, {
            name: "updated_at_timezone", label: "Date", options: {
                filter: false, sort: false, customBodyRender: (value, tableMeta, updateValue) => {
                    const item = this.state.tags[tableMeta.rowIndex];
                    let dateConverted = item.updated_at ? this.props.isodateToDate(item.updated_at) : ''
                    return <div>{dateConverted}</div>
                }
            }
        }, {
            name: "action", label: "Actions", options: {
                filter: false, sort: false, customBodyRender: (value, tableMeta, updateValue) => {
                    const item = tableMeta.tableData[tableMeta.rowIndex];
                    return <div className='mui-column-wrapper min-width-70'>
                            <span
                                id='edit_tag'
                                onClick={(e) => this.setState({
                                    showEditTagModal: true, selectedItem: this.state.filtered[tableMeta.rowIndex]
                                })}
                                className="far fa-edit margin-right-10">
                            </span>
                        <span
                            id='delete_tag'
                            onClick={(e) => this.setState({
                                showDeleteTagModal: true, selectedItem: this.state.filtered[tableMeta.rowIndex]
                            })}
                            className="fas fa-trash-alt">
                            </span>
                    </div>
                }
            }
        },];

        const options = {
            serverSide: false, count: this.state.tags.length, filterType: 'none', selectableRows: 'none', // rowsPerPage: this.state.pageSize,
            viewColumns: false, download: false, print: false, search: true, filter: false, sort: false, // onChangeRowsPerPage: (number) => this.handleRowsPerPageChange(number),
            // page: this.state.currentPage - 1,
            rowsPerPageOptions: [10, 25, 50, 100], textLabels: {
                body: {
                    noMatch: 'There are no tags, add your first tag',
                },
            },
        };
        return (<React.Fragment>
            <h1 className='main-title' id='tags-heading'>Manage Tags</h1>
            <div className="tags-filter">
                {/*<div className="search">*/}
                {/*    <span className='fas fa-search'></span>*/}
                {/*    <input type="text" onChange={(e) => this.props.handleTagsSearch(e)} placeholder='Search'/>*/}
                {/*</div>*/}
                <div className=''/>
                <button id='tags_btn' data-target="#tagModal" className='btn-action'
                        onClick={() => this.setState({showCreateTagModal: true})}>
                    Create New Tag
                </button>
            </div>
            < div className='margin-bottom-10'/>
            {/*{console.log('page size: ', pageSize)}*/}
            {/*{console.log('column width: ', colWidth)}*/}
            {this.state.tagsLoading ? <div className='no-contacts-container panel-container margin-top-20'>
                <ChartLoader/>
            </div> : (!this.state.tags || !this.state.tags.length) ? this.noTagsRenderer() :
                <MuiThemeProvider theme={this.getMuiTheme()}>
                    <MUIDataTable
                        title={""}
                        data={this.state.tags}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>


            }
            <CreateTagModal
                showModal={this.state.showCreateTagModal}
                handleClose={() => this.setState({showCreateTagModal: false})}
                selectedSource={this.props.selected_source}
                maxWidth={600}
                history={this.props.history}
                user={this.props.user}
                updateUserFromServer={this.props.updateUserFromServer}
                tags={this.state.tags}
                handleGetTags={this.props.handleGetTags}
            />
            <DeleteTagModal
                showModal={this.state.showDeleteTagModal}
                handleClose={() => this.setState({showDeleteTagModal: false})}
                selectedSource={this.props.selected_source}
                maxWidth={600}
                history={this.props.history}
                user={this.props.user}
                updateUserFromServer={this.props.updateUserFromServer}
                handleGetTags={this.props.handleGetTags}
                selectedItem={this.state.selectedItem}
            />
            <EditTagModal
                showModal={this.state.showEditTagModal}
                handleClose={() => this.setState({showEditTagModal: false, selectedItem: ''})}
                selectedSource={this.props.selected_source}
                maxWidth={600}
                history={this.props.history}
                user={this.props.user}
                updateUserFromServer={this.props.updateUserFromServer}
                handleGetTags={this.props.handleGetTags}
                selectedItem={this.state.selectedItem}
            />
        </React.Fragment>)
    }
}

export default Tags;